import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddIAQSensorColumnForm from './components/AddIAQSensorColumnForm';
import { reset } from 'redux-form';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import userSettingEnum from '../../constants/userSetting.enum';
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider';
import { cloneDeep } from 'lodash';
import { iaqColumnList } from '../../constants/IaqKpiColumn.constant';

const AddIAQSensorColumn = (props: any) => {

  let kpis: any = [];
  let selectedColumns: any = [];

  const [columnList, setColumnList] = useState<any>([]);
  const dispatch = useDispatch();;
  const { columnLists, addColumn }: any = useSelector((state: IState) => { return state.column });
  //let localColumnList = props.model.toLowerCase() === modelEnum.AQS.toLowerCase() ? cloneDeep(aqsColumnList) : cloneDeep(fdsColumnList);

  const localColumnListCloner = (model:string) => {
    return cloneDeep(iaqColumnList);
  }

  let localColumnList = localColumnListCloner(props.model.toLowerCase());

  const GetAndAddColumn = (isSubmitColumn: boolean) => {
    switch (props.from) {
      case 'LineChart': {
        if (isSubmitColumn) {
          dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.LineChartColumnIAQ));
        } else {
          dispatch(actions.getUserSetting(userSettingEnum.LineChartColumnIAQ));
        }
        break;
      }
      case 'SensorData': {
        if (isSubmitColumn) {
          dispatch(actions.addUserSetting(JSON.stringify(selectedColumns), userSettingEnum.SensorColumnIAQ));
          } else {
            dispatch(actions.getUserSetting(userSettingEnum.SensorColumnIAQ));
          }
          break;
      }
    }
  }

  useEffect(() => {
    GetAndAddColumn(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (columnLists.success) {
      if (columnLists.columns.Value) {
        const columnArr = JSON.parse(columnLists.columns.Value);
        if (props.from === 'LineChart') {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          localColumnList = cloneDeep(localColumnList.filter((item: any) => !(item.id === 1 || item.id === 0)));
        }
        localColumnList.forEach((val: any) => {
          columnArr.forEach((val1: any) => {
            if (val.value === val1) {
              val.isChecked = true;
            }
            else if (val.isChecked && !columnArr.includes(val.value)) {
              val.isChecked = false;
            }
          });
        });
      }
      else{
        if (props.from === 'LineChart') {
          // eslint-disable-next-line react-hooks/exhaustive-deps
          localColumnList = cloneDeep(localColumnList.filter((item: any) => !(item.id === 1 || item.id === 0)));
        }
      }
      setColumnList(localColumnList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnLists.success])

  useEffect(() => {
    if (addColumn.success) {
      toast.success(formatMessage('Message_Show/Hide_Column_Updated_Success'));
      onModalClosed();
      dispatch(actions.resetUserSettingState());
      props.columnSave();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn.success]);

  useEffect(() => {
    if (addColumn.error) {
      toast.error(formatMessage(addColumn.error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn.error])

  const onSubmitForm = async (values: any) => {
    selectedColumns = [];
    let successflag:boolean=true;
    columnList.forEach((val: any) => {
      if (val.isChecked)
        JSON.stringify(selectedColumns.push(val.value));
    });

    if (selectedColumns.length > 6 && props.from === 'LineChart') {
      successflag=false;
      toast.warn(formatMessage('Line_Chart_KPI_Validation'));
    } else if(selectedColumns.length === 0 && props.from === 'LineChart'){
      successflag=false;
      toast.warn(formatMessage('Line_Chart_KPI_Validation_Min'));
    }
    else {
      GetAndAddColumn(true);
    }
    // if(successflag)
    //toast.success(formatMessage('Message_Show/Hide_Column_Updated_Success'));
    //onModalClosed();
  }

  const onModalClosed = () => {
    //dispatch(actions.resetUserSettingState());
    dispatch(actions.resetUsersettingAddState());
    dispatch(reset('AddIAQSensorColumnForm'));
    props.modalClosed();
  }

  const handleCheckChildElement = (event: any) => {
    kpis = columnList;
    if (event.target.value === "SelectAll")
    {
      kpis.forEach((kpi: any) => {
        kpi.isChecked = event.target.checked;
    })
    }
    else{
      kpis.forEach((kpi: any) => {
        if (kpi.value === event.target.value)
          kpi.isChecked = event.target.checked;
      })
    }
  }

  return (
    <React.Fragment>
      {columnLists.columns !== undefined && !columnLists.loading &&
        <AddIAQSensorColumnForm
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          columnList={columnList}
          from={props.from}     
          model={props.model.toLowerCase()}     
          isLoading={addColumn.loading}
          checkChildElement={handleCheckChildElement}
        />
      }
    </React.Fragment>
  );
};

export default AddIAQSensorColumn;
